"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StudentProgressReportController = /** @class */ (function () {
    function StudentProgressReportController(UserService, UsersModel) {
        var _this = this;
        this.loading = true;
        this.student = UserService.getCurrentUser();
        this.courses = [];
        UsersModel.getStudentUsageDetails(this.student.id).then(function (response) {
            _this.loading = false;
            _this.usagedetails = response.data;
        });
        UsersModel.getStudentCourseDetails(this.student.id).then(function (response) {
            _this.loading = false;
            _this.courses = response.data;
        });
    }
    return StudentProgressReportController;
}());
StudentProgressReportController.$inject = ["UserService", "UsersModel"];
exports.default = StudentProgressReportController;
